export default __webpack_public_path__ + "static/media/pinkExpress_background.3362203d.png";